import { render } from "./Login.vue?vue&type=template&id=27d5e184&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "@/assets/scss/login.scss?vue&type=style&index=0&id=27d5e184&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d5e184"]])

export default __exports__